import TrackingElement from '../../elements/tracking/TrackingElement';
import { defineElement } from '@webtides/element-js';
import pushCustomTrackingEvent from '../../elements/tracking/helpers/pushCustomTrackingEvent';
import SpecFilterEvents from '../../structures/_category-page/spec-filter/SpecFilterEvents';
import { trackViewItemList } from '../../elements/tracking/events/trackViewItemList';
import toTrackableCategoryProduct from '../../elements/tracking/transformer/toTrackableListItemProduct';

class CategoryPageTracking extends TrackingElement {
    connected() {
        super.connected();

        if (this.$trackingTarget) {
            this.$trackingTarget.addEventListener('PRODUCTS_CHANGED', ({ detail: products }) => {
                trackViewItemList(this.id, this.templateName, this.pageTitle, products, toTrackableCategoryProduct);
            });

            this.$trackingTarget.addEventListener(SpecFilterEvents.FILTER_CHANGE, ev => {
                const { detail } = ev;
                const filterKeys = Object.keys(detail);
                if (filterKeys.length > 0) {
                    const filterKey = filterKeys[0];
                    this.trackFilterChange(
                        filterKey,
                        detail[filterKey].filter(filterKey => filterKey.selected)
                    );
                }
            });
        }
    }

    properties() {
        return {
            id: '',
            pageTitle: '',
            templateName: '',
        };
    }

    getTrackingTarget() {
        return document.querySelector('category-page');
    }

    trackFilterChange(filterKey, selectedFilters) {
        pushCustomTrackingEvent({
            action: filterKey,
            category: 'filter',
            label: selectedFilters,
        });
    }
}

defineElement('category-page-tracking', CategoryPageTracking);
